import React, { useState, useRef, useEffect } from "react";
import moment from "moment-timezone";
import { ChevronDown, Clock } from "lucide-react";

export default function TimezoneSelect({
  selectedTimezone,
  setSelectedTimezone,
}) {
  const timezones = moment.tz.names();

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const containerRef = useRef(null);

  const filtered = timezones.filter((tz) =>
    tz.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (tz) => {
    setSelectedTimezone(tz);
    setSearch("");
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formatLabel = (tz) => {
    const abbr = moment.tz(tz).zoneAbbr();
    const offset = moment.tz(tz).format("Z");
    return `${tz.replace(/_/g, " ")} (${abbr})  UTC${offset}`;
  };

  return (
    <div style={{ position: "relative" }} ref={containerRef}>
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 12px",
          border: "1px solid #D1D5DB",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: "#fff",
          gap: "8px",
          fontSize: "14px",
        }}
      >
        <span role="img" aria-label="clock">
          <Clock size={18} color="#717680" />
        </span>
        <span
          style={{
            flexGrow: 1,

            fontSize: "12px",
          }}
          className="text-xs text-gray-800"
        >
          {selectedTimezone
            ? formatLabel(selectedTimezone)
            : "Select a timezone"}
        </span>
        <span style={{ marginLeft: "auto" }}>
          <ChevronDown size={16} color="#717680" />
        </span>
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            border: "1px solid #D1D5DB",
            borderRadius: "8px",
            marginTop: "4px",
            maxHeight: "250px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          <input
            autoFocus
            type="text"
            placeholder="Search timezone..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 12px",
              border: "none",
              borderBottom: "1px solid #eee",
              fontSize: "14px",
              outline: "none",
            }}
            className="text-xs text-gray-800"
          />
          {filtered.length > 0 ? (
            filtered.map((tz) => (
              <div
                key={tz}
                onClick={() => handleSelect(tz)}
                style={{
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
                className="text-xs text-gray-800 hover:bg-[#207C9733] hover:text-secondary"
              >
                <span role="img" aria-label="clock">
                  <Clock size={18} color=" #252b37" />
                </span>
                {formatLabel(tz)}
              </div>
            ))
          ) : (
            <div
              style={{ padding: "8px 12px", color: "#999", fontSize: "12px" }}
            >
              No matches found.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
